import type { Address } from 'viem'

import { cn } from '@repo/ui'

import { TokenIcon, type TokenIconProps } from './TokenIcon'

interface TokenPairProps {
  loanToken: { address?: Address; symbol: string }
  collateralToken: { address?: Address; symbol: string }
  size?: TokenIconProps['size']
  variant: 'overlapping' | 'inline'
  className?: string
  showSymbols?: boolean
}

export function TokenPair({
  loanToken,
  collateralToken,
  size = 'sm',
  variant,
  showSymbols = true,
  className
}: TokenPairProps) {
  if (variant === 'overlapping') {
    return (
      <div className={cn('flex -space-x-2', className)}>
        <TokenIcon
          address={collateralToken.address}
          symbol={collateralToken.symbol}
          size={size}
          className="border-2 border-transparent"
        />
        <TokenIcon
          address={loanToken.address}
          symbol={loanToken.symbol}
          size={size}
          className="border-2 border-transparent"
        />
      </div>
    )
  }

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <TokenIcon address={collateralToken.address} symbol={collateralToken.symbol} size={size} />
      {showSymbols && <span className="text-xs">{collateralToken.symbol}</span>}

      {showSymbols && <span className="text-muted-foreground text-xs">/</span>}

      <TokenIcon address={loanToken.address} symbol={loanToken.symbol} size={size} />
      {showSymbols && <span className="text-xs">{loanToken.symbol}</span>}
    </div>
  )
}
